import { Injectable } from '@angular/core';
import {webapi} from '../../shared/my-constants';
import {Headers, Http, Response} from '@angular/http';

@Injectable()
export class GenerateTokenService {
    private headers = new Headers({'Content-Type': 'application/json'});
    // private ListRecord = webapi + 'mst_generate_token/list/?';
   // private ListRecord1 = webapi + 'mst_generate_token/tokenlist/?';
    private ListRecord = webapi + 'mst_generate_token/tokenlist/?';
    private EditRecord = webapi + 'mst_generate_token/update';
    private AddRecord = webapi + 'mst_generate_token/create';
    private GetRecord = webapi + 'mst_generate_token/byid/';
    private NextToken = webapi + 'mst_generate_token/callnexttoken';
    private GenerateToken = webapi + 'mst_generate_token/generatetoken';
    private TokenDisplayList = webapi + 'mst_generate_token/displayTokens/?';


  constructor(private http: Http) { }

    /*getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }*/

    getAllRecordService2(fromdate: any, todate: any, currentPage: any, size: any, qString: any, sort: any, col: any ): Promise<any> {
        return this.http.get(this.ListRecord + 'fromdate=' + fromdate  + '&todate=' + todate + '&page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getTokenToDisplay(): Promise<any> {
        return this.http.get(this.TokenDisplayList)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getNextToken(): Promise<any> {
        return this.http.get(this.NextToken ).toPromise().then(response => response.json()).catch(this.handleError);
    }

    generateToken(): Promise<any> {
        return this.http.get(this.GenerateToken).toPromise().then(response => response.json()).catch(this.handleError);
    }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordService(model: any) {
        return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }

}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/opd/generate-token/generate-token.service.ts